import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';
import { VisualPicker } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker';

interface SortableComparePlanFieldProps {
  planId: string;
  label: string;
  checked: boolean;
  disabled: boolean;
  onChange(evt: React.ChangeEvent<HTMLInputElement>): void;
}

export const SortableComparePlanField = ({
  planId,
  label,
  checked,
  disabled,
  onChange,
}: SortableComparePlanFieldProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: planId,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gridGap={8}
    >
      <Box flex={1} minWidth={0}>
        <VisualPicker
          variant="checkbox"
          label={label}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          mt="8"
        />
      </Box>

      <IconButton
        icon="fas fa-grip-vertical"
        variant="subtleInactive"
        style={{ cursor: 'grab', flexShrink: 0 }}
        aria-label={`Drag to reorder ${label}`}
        {...attributes}
        {...listeners}
      />
    </Box>
  );
};
